import { useContext } from 'react';
import { CvVideosListContext } from '../contexts/cvVideosListContext';

const useGetCvVideosList = () => {
  const context = useContext(CvVideosListContext);
  if (!context) {
    throw new Error(
      'useCvVideosList must be used within a CvVideosList Provider',
    );
  }
  return context;
};

export default useGetCvVideosList;
